export default [
	// {
	// 	path: '/',
	// 	component: require('../pages/index.vue').default
	// },
	{
		// path: '/login',
		path: '/',
		name: 'login',
		component: require('../pages/login.vue').default
	},{
		path: '/privacy-statement',
		name: 'privacy-statement',
		component: require('../pages/privacy-statement.vue').default
	},{
		path: '/register',
		name: 'register',
		component: require('../pages/registration.vue').default
	},{
		path: '/membership',
		name: 'membership',
		component: require('../pages/membership/index.vue').default
	},{
		path: '/reset-password/:token',
		nmae: 'reset-password',
		component: require('../pages/reset-password.vue').default
	},{
		path: '*',
		name: 'page-not-found',
		component: require('../pages/page-not-found.vue').default
	}
]